import { RootState } from '@shared/types';
import { User } from '../types';

export const selectUsers = (state: RootState) => state.users.users;
export const selectStudents = (state: RootState) => state.users.students;
export const selectGetStudentsStatus = (state: RootState) => state.users.getStudentsStatus;
export const selectUserById = (userId: number) => (state: RootState) =>
    state.users.users.find((user) => user.pk === userId);
export const selectAllUsersAreInStateStatus = (state: RootState) => state.users.allUsersAreInState;
export const selectGetAllUsersStatus = (state: RootState) => state.users.getAllUsersStatus;
export const selectIsUserDownloading = (userId: User['pk'] | null) => (state: RootState) =>
    userId && Boolean(state.users.usersIdsDownloading.find((downloadingUserId) => downloadingUserId === userId));
